import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import FileUpload from './CsvDropzone';
import Swal from 'sweetalert2';
import socket from '../tools/socke';
import AsistenciasCurso from './Asistencias';
import ObtieneDatosCookies from '../obtieneDatosCookiesUsuario';
import * as XLSX from 'xlsx'
import { saveAs } from "file-saver";
import comprueboPermisos from "../tools/comprueboPermisos";
import DetectarHuerfanos from './DetectarHuerfanos';
import ScannerAsistenciaQR from './ScannerAsistenciaQR';
import './TablaAlumnosCurso.css';
const TablaAlumnosCurso = ({
  idCurso,
  division,
  nombreCurso,
  escuelaDePolicia,
  curso
}) => {
  const [alumnos, setAlumnos] = useState([]);
  const [moduloActivo, setModuloActivo] = useState("matriculaciones");
  const [divisionMoodle, setDivisionMoodle] = useState(null);
  const [loadingDivision, setLoadingDivision] = useState(false);
  const [fechaDevuelta, setFechaDevuelta] = useState();
const [mostrarQR, setMostrarQR] = useState(false);
  const [filtroAlumno, setFiltroAlumno] = useState('');
  const [analisisMatricula, setAnalisisMatricula] = useState(null);
  const [mostrarRevisionMatricula, setMostrarRevisionMatricula] = useState(false);
  const [ejecutandoMatricula, setEjecutandoMatricula] = useState(false);
  const [ingresandoAula, setIngresandoAula] = useState(false);

  const Usuario = ObtieneDatosCookies();

  useEffect(() => {
    if (idCurso && division) {
      obtenerDivisionMoodle();
      obtenerAlumnos(); // 👈 ya la tenías
    }
  }, [idCurso, division]);
const descargarExcelAlumnos = () => {
  if (!alumnosOrdenados.length) return;

  const datosExcel = alumnosOrdenados.map(({ alumno, ni, escalafon, sub_escalafon }, index) => ({
    "#": index + 1,
    DNI: alumno.alumnoDni,
    Apellido: alumno.apellido,
    Nombres: alumno.nombres,
    Email: alumno.emailAlumno,
    NI: ni || "Sin datos",
    Escalafon: escalafon || "Sin datos",
    "Sub Escalafon": sub_escalafon || "Sin datos",
  }));

  const worksheet = XLSX.utils.json_to_sheet(datosExcel);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Alumnos");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(data, "alumnos_matriculados_" + curso.nombreCurso + ".xlsx");
};
  const obtenerDivisionMoodle = async () => {
    try {
      setLoadingDivision(true);
//       console.log(division, idCurso)
      const res = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/getDivisionMoodle",
        {
          idCurso: idCurso,
          division: division
        }
      );
//       console.log(res)
      setDivisionMoodle(res.data.data);

    } catch (error) {
      console.error(
        "Error obteniendo división Moodle",
        error.response?.data || error.message
      );
    } finally {
      setLoadingDivision(false);
    }
  };


  // ============================================================
  // ACCESO A MOODLE + MATRÍCULA AUTOMÁTICA OPTIMIZADA
  // ============================================================
  // IMPORTANTE:
  // - NO vuelve a consultar categorias_id.
  // - Usa directamente divisionMoodle.materiasIdMoodle.
  // - El backend compara y matricula únicamente las materias faltantes.
  // - Si el usuario ya está actualizado, la respuesta es prácticamente inmediata.
  // ============================================================

  const obtenerUrlAulaDivision = () => {
    const categoriaId = Number(divisionMoodle?.categoriaId);

    if (!Number.isFinite(categoriaId) || categoriaId <= 0) {
      return null;
    }

    return `https://cursos.isepsantafe.net.ar/course/index.php?categoryid=${categoriaId}`;
  };

  const obtenerMateriasDivisionMoodle = () => {
    try {
      const valor = divisionMoodle?.materiasIdMoodle;

      if (!valor) return [];

      let materias = [];

      if (Array.isArray(valor)) {
        materias = valor;
      } else if (typeof valor === "string") {
        const parseado = JSON.parse(valor);
        materias = Array.isArray(parseado) ? parseado : [];
      }

      return [
        ...new Set(
          materias
            .map((id) => Number(id))
            .filter((id) => Number.isFinite(id) && id > 0)
        ),
      ];
    } catch (error) {
      console.error("Error parseando materiasIdMoodle:", error);
      return [];
    }
  };

  const abrirAulaDivision = async () => {
    if (ingresandoAula) return;

    const categoriaId = Number(divisionMoodle?.categoriaId);
    const urlAula = obtenerUrlAulaDivision();
    const materiasIdMoodle = obtenerMateriasDivisionMoodle();

    if (!urlAula) {
      console.log("divisionMoodle recibido:", divisionMoodle);

      await Swal.fire({
        title: "Aula Moodle no disponible",
        html: `
          <div style="text-align:left; line-height:1.55">
            <p>No se encontró un <b>categoriaId</b> válido para esta división.</p>
            <p>Curso: <b>${nombreCurso || curso?.nombreCurso || idCurso}</b></p>
            <p>División: <b>${division}</b></p>
          </div>
        `,
        icon: "warning",
        confirmButtonText: "Entendido",
      });

      return;
    }

    if (!Usuario?.identificacion) {
      await Swal.fire(
        "Usuario no identificado",
        "No se pudo obtener la identificación del usuario de SIGEDI.",
        "warning"
      );
      return;
    }

    if (!materiasIdMoodle.length) {
      await Swal.fire({
        title: "Aula sin materias configuradas",
        html: `
          <div style="text-align:left; line-height:1.55">
            <p>La división tiene categoría Moodle <b>${categoriaId}</b>, pero no posee materias configuradas en <b>materiasIdMoodle</b>.</p>
            <p>Se abrirá igualmente la categoría Moodle.</p>
          </div>
        `,
        icon: "info",
        confirmButtonText: "Ingresar",
      });

      window.open(urlAula, "_blank", "noopener,noreferrer");
      return;
    }

    // Abrimos la pestaña inmediatamente para que Chrome no la bloquee
    // mientras esperamos la verificación/matrícula.
    const ventanaAula = window.open("", "_blank");

    if (!ventanaAula) {
      await Swal.fire(
        "Ventana bloqueada",
        "El navegador bloqueó la nueva pestaña. Permití ventanas emergentes para este sitio y volvé a intentar.",
        "warning"
      );
      return;
    }

    try {
      setIngresandoAula(true);

      try {
        ventanaAula.document.title = "Preparando aula Moodle...";
        ventanaAula.document.body.innerHTML = `
          <div style="font-family:Arial,sans-serif;padding:40px;text-align:center">
            <h2>Preparando acceso al aula...</h2>
            <p>Verificando tu matrícula en Moodle.</p>
          </div>
        `;
      } catch (errorVentana) {
        console.log("No se pudo escribir mensaje temporal en la pestaña:", errorVentana);
      }

      // Ya NO consultamos categorias_id.
      // Usamos directamente las materias que getDivisionMoodle ya nos devolvió.
      const responseMatricula = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/moodles/guardarClaseUsuario",
        {
          identificacionUsuario: Usuario.identificacion,
          clase: 9,
          materiasIdMoodle,
          platformUrl: "https://cursos.isepsantafe.net.ar",
        }
      );

      const resultadoMatricula = responseMatricula.data || {};

      console.log("Acceso Moodle actualizado:", resultadoMatricula);

      if (
        resultadoMatricula.ok === false &&
        Array.isArray(resultadoMatricula.errores) &&
        resultadoMatricula.errores.length > 0
      ) {
        console.warn(
          "La matrícula terminó con observaciones:",
          resultadoMatricula.errores
        );
      }

      // Cuando el backend terminó, enviamos la pestaña al aula.
      ventanaAula.location.replace(urlAula);
    } catch (error) {
      try {
        ventanaAula.close();
      } catch (errorCerrarVentana) {
        console.log("No se pudo cerrar la pestaña temporal:", errorCerrarVentana);
      }

      console.error(
        "Error preparando acceso Moodle:",
        error.response?.data || error.message
      );

      await Swal.fire(
        "No se pudo ingresar al aula",
        error.response?.data?.message ||
          error.response?.data?.detalle ||
          "Ocurrió un error al verificar o actualizar la matrícula en Moodle.",
        "error"
      );
    } finally {
      setIngresandoAula(false);
    }
  };

  const obtenerAlumnos = async () => {
    try {
      const res = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/devuelveAlumnosCursos`,
        { idCurso, division }
      );
//       console.log(res)
      setAlumnos(res.data);
    } catch (error) {
      console.error('Error al obtener alumnos:', error);
    }
  };

  const quitaAlumno = async (alumno) => {

    const confirmacion = await Swal.fire({
      title: '¿Borrar alumno?',
      text: `El alumno ${alumno.alumnoDni} será eliminado del curso.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, borrar alumno',
      cancelButtonText: 'Cancelar'
    });

    if (!confirmacion.isConfirmed) return;

    try {
      const token = btoa(
        `${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`
      );

      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/quitaAlumno`,
        {
          alumnoDni: alumno.alumnoDni,
          idCurso,
          divisionMoodle,
          platformUrl: curso.tienePlataforma,
          usuarioSigedi: Usuario.identificacion
        },
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (response.data.success) {
        Swal.fire('Borrado', response.data.message, 'success');
        socket.emit('novedades matriculacion', [
          String(alumno.alumnoDni),
        ]);
        obtenerAlumnos();
      } else {
        Swal.fire('Atención', response.data.message, 'warning');
      }
    } catch (error) {
      Swal.fire(
        'Error',
        error.response?.data?.message || 'Error al borrar alumno',
        'error'
      );
    }
  };

  const desmatricular = async (alumno) => {

    const confirmacion = await Swal.fire({
      title: 'Suspender alumno?',
      text: `El alumno ${alumno.alumnoDni} será suspendido del curso.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, suspender',
      cancelButtonText: 'Cancelar'
    });

    if (!confirmacion.isConfirmed) return;

    try {
      const token = btoa(
        `${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`
      );

      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/desmatriculaAlumno`,
        {
          alumnoDni: alumno.alumnoDni,
          idCurso,
          divisionMoodle,
          platformUrl: curso.tienePlataforma,
          usuarioSigedi: Usuario.identificacion
        },
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (response.data.success) {
        Swal.fire('Suspendido', response.data.message, 'success');
        socket.emit('novedades matriculacion', [
          String(alumno.alumnoDni),
        ]);
        obtenerAlumnos();
      } else {
        Swal.fire('Atención', response.data.message, 'warning');
      }
    } catch (error) {
      Swal.fire(
        'Error',
        error.response?.data?.message || 'Error al suspender',
        'error'
      );
    }
  };

const suspenderTodosLosAlumnos = async () => {

  if (!alumnosOrdenados?.length) {
    Swal.fire("Atención", "No hay alumnos para suspender", "info");
    return;
  }

  const { isConfirmed } = await Swal.fire({
    title: "⚠️ Suspender todos los alumnos",
    html: `
      Se suspenderán <b>${alumnosOrdenados.length}</b> alumnos.<br><br>
      Esta acción puede revertirse luego.
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sí, suspender todos",
    cancelButtonText: "Cancelar"
  });

  if (!isConfirmed) return;

  try {

    Swal.fire({
      title: "Procesando...",
      html: `<b>0</b> de <b>${alumnosOrdenados.length}</b> alumnos suspendidos`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });

    const token = btoa(
      `${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`
    );

    const total = alumnosOrdenados.length;
    let contador = 0;
    let suspendidosDni = [];

    // Recorremos todos
    for (const { alumno } of alumnosOrdenados) {

      try {
        const response = await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/desmatriculaAlumno`,
          {
            alumnoDni: alumno.alumnoDni,
            idCurso,
            divisionMoodle,
            platformUrl: curso.tienePlataforma,
          usuarioSigedi: Usuario.identificacion
          },
          { headers: { Authorization: `Basic ${token}` } }
        );

        if (response.data.success) {
          contador++;
          suspendidosDni.push(String(alumno.alumnoDni));
        }

      } catch (error) {
        console.error("Error con alumno:", alumno.alumnoDni);
      }

      Swal.update({
        html: `<b>${contador}</b> de <b>${total}</b> alumnos suspendidos`
      });
    }

    Swal.close();

    if (suspendidosDni.length > 0) {
      socket.emit('novedades matriculacion', suspendidosDni);
    }

    await obtenerAlumnos();

    Swal.fire(
      "Finalizado",
      `${contador} alumnos suspendidos correctamente`,
      "success"
    );

  } catch (error) {

    Swal.close();

    Swal.fire(
      "Error",
      "Ocurrió un error al suspender alumnos",
      "error"
    );
  }
};
const actualizarAlumnoAnalisis = (dni, cambios) => {
  setAnalisisMatricula((prev) => {
    if (!prev) return prev;

    return {
      ...prev,
      alumnos: prev.alumnos.map((registro) =>
        String(registro.alumnoDni) === String(dni)
          ? { ...registro, ...cambios }
          : registro
      ),
    };
  });
};

const cambiarMatriculaAlumno = (registro) => {
  if (!registro.valido) return;

  actualizarAlumnoAnalisis(registro.alumnoDni, {
    matricular: !registro.matricular,
  });
};

const cambiarMateriaAlumno = async (registro, materia) => {
  if (!registro.valido || materia.tipo === "sin_clasificar") return;

  const seleccionadas = Array.isArray(registro.materiasSeleccionadas)
    ? registro.materiasSeleccionadas.map(Number)
    : [];

  const courseid = Number(materia.courseid);
  const estaSeleccionada = seleccionadas.includes(courseid);

  let autorizaOperacionales = registro.autorizaOperacionales === true;

  if (
    !estaSeleccionada &&
    materia.tipo === "operacional" &&
    !registro.puedeCursarOperacionales
  ) {
    const confirmacion = await Swal.fire({
      title: "Autorizar materia operacional",
      html: `
        <div style="text-align:left">
          <p><b>${registro.apellido}, ${registro.nombres}</b> no pertenece al escalafón general.</p>
          <p>¿Deseás autorizar manualmente la matrícula en:</p>
          <p><b>${materia.nombre}</b>?</p>
        </div>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, autorizar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#d97706",
    });

    if (!confirmacion.isConfirmed) return;

    autorizaOperacionales = true;
  }

  const nuevasMaterias = estaSeleccionada
    ? seleccionadas.filter((id) => id !== courseid)
    : [...seleccionadas, courseid];

  const quedanOperacionalesSeleccionadas = nuevasMaterias.some((id) => {
    const materiaEncontrada = analisisMatricula?.materias?.todas?.find(
      (item) => Number(item.courseid) === Number(id)
    );

    return materiaEncontrada?.tipo === "operacional";
  });

  actualizarAlumnoAnalisis(registro.alumnoDni, {
    materiasSeleccionadas: nuevasMaterias,
    autorizaOperacionales:
      autorizaOperacionales && quedanOperacionalesSeleccionadas,
  });
};

const seleccionarMateriasGrupo = (tipo, seleccionar) => {
  setAnalisisMatricula((prev) => {
    if (!prev) return prev;

    const idsGrupo = (prev.materias?.todas || [])
      .filter((materia) => materia.tipo === tipo)
      .map((materia) => Number(materia.courseid));

    return {
      ...prev,
      alumnos: prev.alumnos.map((registro) => {
        if (!registro.valido || !registro.matricular) return registro;

        const actuales = Array.isArray(registro.materiasSeleccionadas)
          ? registro.materiasSeleccionadas.map(Number)
          : [];

        if (tipo === "operacional" && !registro.puedeCursarOperacionales) {
          return registro;
        }

        const nuevas = seleccionar
          ? [...new Set([...actuales, ...idsGrupo])]
          : actuales.filter((id) => !idsGrupo.includes(id));

        return {
          ...registro,
          materiasSeleccionadas: nuevas,
        };
      }),
    };
  });
};

const cerrarRevisionMatricula = () => {
  if (ejecutandoMatricula) return;
  setMostrarRevisionMatricula(false);
  setAnalisisMatricula(null);
};

const ejecutarMatriculaAnalizada = async () => {
  if (!analisisMatricula) return;

  const alumnosConfirmados = analisisMatricula.alumnos.filter(
    (registro) => registro.valido && registro.matricular
  );

  if (!alumnosConfirmados.length) {
    Swal.fire(
      "Atención",
      "No hay alumnos seleccionados para matricular.",
      "warning"
    );
    return;
  }

  const materiasSeleccionadasTotal = alumnosConfirmados.reduce(
    (total, registro) =>
      total +
      (Array.isArray(registro.materiasSeleccionadas)
        ? registro.materiasSeleccionadas.length
        : 0),
    0
  );

  const noTieneMateriasMoodle =
    (analisisMatricula.materias?.todas || []).length === 0;

  const confirmacion = await Swal.fire({
    title: "Confirmar matrícula",
    html: `
      <div style="text-align:left;line-height:1.55">
        <p>Se procesarán <b>${alumnosConfirmados.length}</b> alumnos.</p>
        ${
          noTieneMateriasMoodle
            ? `<p>El curso no posee materias Moodle asociadas. Se realizará únicamente la matrícula interna.</p>`
            : `<p>Se realizarán <b>${materiasSeleccionadasTotal}</b> asignaciones de alumnos a materias Moodle.</p>`
        }
        <p>Las selecciones manuales realizadas en la revisión serán respetadas.</p>
      </div>
    `,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sí, ejecutar matrícula",
    cancelButtonText: "Volver a revisar",
  });

  if (!confirmacion.isConfirmed) return;

  try {
    setEjecutandoMatricula(true);

    Swal.fire({
      title: "Ejecutando matrícula...",
      html: `
        Procesando <b>${alumnosConfirmados.length}</b> alumnos.
        <br><br>
        No cierres esta ventana.
      `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading(),
    });

    const response = await axios.post(
      "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/ejecutarMatriculaDesdeCSV",
      {
        alumnos: alumnosConfirmados,
        idCurso,
        division,
        divisionMoodle,
        platformUrl: curso?.tienePlataforma || null,
        usuarioSigedi: Usuario.identificacion,
      }
    );

    Swal.close();

    const resultado = response.data || {};
    const procesados = Array.isArray(resultado.procesados)
      ? resultado.procesados
      : [];
    const errores = Array.isArray(resultado.errores)
      ? resultado.errores
      : [];
    const omitidos = Array.isArray(resultado.omitidos)
      ? resultado.omitidos
      : [];

    const dnisProcesados = procesados
      .map((registro) =>
        typeof registro === "object" ? registro.alumnoDni : registro
      )
      .filter(Boolean)
      .map(String);

    if (dnisProcesados.length) {
      socket.emit("novedades matriculacion", dnisProcesados);
    }

    setMostrarRevisionMatricula(false);
    setAnalisisMatricula(null);

    await obtenerAlumnos();

    await Swal.fire({
      title: errores.length ? "Proceso finalizado con observaciones" : "Matrícula finalizada",
      html: `
        <div style="text-align:left;line-height:1.6">
          <p>✅ Procesados: <b>${procesados.length}</b></p>
          <p>↪️ Omitidos: <b>${omitidos.length}</b></p>
          <p>⚠️ Errores u observaciones: <b>${errores.length}</b></p>
          <p>📚 Materias Moodle procesadas: <b>${resultado.moodle?.materiasProcesadas?.length || 0}</b></p>
          ${
            resultado.moodle?.motivoNoEjecutado
              ? `<p><b>Moodle:</b> ${resultado.moodle.motivoNoEjecutado}</p>`
              : ""
          }
        </div>
      `,
      icon: errores.length ? "warning" : "success",
    });
  } catch (error) {
    Swal.close();

    console.error(
      "Error ejecutando matrícula:",
      error.response?.data || error.message
    );

    Swal.fire(
      "Error",
      error.response?.data?.message ||
        error.response?.data?.detalle ||
        "No se pudo ejecutar la matrícula.",
      "error"
    );
  } finally {
    setEjecutandoMatricula(false);
  }
};

const handleCsvUpload = async (data) => {
  if (!Array.isArray(data) || !data.length) {
    Swal.fire("Error", "CSV vacío o inválido", "warning");
    return;
  }

  /*
   * El correo es opcional. Los obligatorios son:
   * DNI, apellido y nombres.
   */
  const filasPreparadas = data
    .map((row, index) => ({
      fila: index + 1,
      alumnoDni: String(row?.alumnoDni || "").replace(/\D/g, ""),
      apellido: String(row?.apellido || "").trim(),
      nombres: String(row?.nombres || "").trim(),
      emailAlumno: String(row?.emailAlumno || "").trim() || null,
    }))
    .filter(
      (row) => row.alumnoDni || row.apellido || row.nombres || row.emailAlumno
    );

  if (!filasPreparadas.length) {
    Swal.fire("Error", "No hay filas con información para analizar.", "error");
    return;
  }

  const filasConDatosObligatorios = filasPreparadas.filter(
    (row) => row.alumnoDni && row.apellido && row.nombres
  ).length;

  const confirmacion = await Swal.fire({
    title: "Analizar archivo",
    html: `
      <div style="text-align:left;line-height:1.55">
        <p>Filas detectadas: <b>${filasPreparadas.length}</b></p>
        <p>Con datos obligatorios completos: <b>${filasConDatosObligatorios}</b></p>
        <p>Primero se realizará una revisión. Todavía no se modificará ningún registro.</p>
      </div>
    `,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Analizar matrícula",
    cancelButtonText: "Cancelar",
  });

  if (!confirmacion.isConfirmed) return;

  try {
    Swal.fire({
      title: "Analizando matrícula...",
      html: `
        Consultando alumnos, escalafones y materias.
        <br><br>
        Todavía no se está matriculando a nadie.
      `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading(),
    });

    const response = await axios.post(
      "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/analizarMatriculaDesdeCSV",
      {
        alumnos: filasPreparadas,
        idCurso,
        division,
        divisionMoodle,
        platformUrl: curso?.tienePlataforma || null,
      }
    );
// console.log(response)
    Swal.close();

    const resultado = response.data;

    if (!resultado?.ok) {
      Swal.fire(
        "No se pudo analizar",
        resultado?.message || "El servidor no devolvió un análisis válido.",
        "error"
      );
      return;
    }

    setAnalisisMatricula(resultado);
    setMostrarRevisionMatricula(true);
  } catch (error) {
    Swal.close();

    console.error(
      "Error analizando CSV:",
      error.response?.data || error.message
    );

    Swal.fire(
      "Error",
      error.response?.data?.message ||
        error.response?.data?.detalle ||
        "No se pudo analizar el archivo.",
      "error"
    );
  }
};

  const descargarEjemploExcel = () => {
    const data = [
      {
        alumnoDni: "12345678",
        apellido: "Perez",
        nombres: "Juan",
        emailAlumno: "juan@mail.com"
      }
    ];

    // Crear hoja
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Crear libro
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Alumnos");

    // Generar archivo y descargar
    XLSX.writeFile(workbook, "ejemplo_alumnos.xlsx");
  };
const doyPresente = async () => {
  const respuesta = await Swal.fire({
    title: 'Registrar asistencia',
    text: 'Elegí el método',
    icon: 'question',
    showDenyButton: true,
    showCancelButton: true,
    confirmButtonText: '📋 Manual',
    denyButtonText: '📷 QR',
    cancelButtonText: 'Cancelar'
  });

  // ❌ canceló
  if (respuesta.isDismissed) return;

  // 📷 QR
  if (respuesta.isDenied) {
    setMostrarQR(true);
    return;
  }

  // 📋 MANUAL (tu lógica original)
  const { value: dni } = await Swal.fire({
    title: 'Registrar asistencia manual',
    text: 'Ingresá el DNI del alumno',
    input: 'number',
    inputPlaceholder: 'DNI',
    showCancelButton: true,
    confirmButtonText: 'Registrar',
    cancelButtonText: 'Cancelar',
    inputValidator: (value) => {
      if (!value) {
        return 'Tenés que ingresar un DNI';
      }
    }
  });

  if (!dni) return;

  try {
    const response = await fetch(
      'https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/registrarAsistenciaManual',
      {
        method: 'POST',
        credentials: "include",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          alumnoDni: dni,
          cursoId: idCurso,
          token:
            "no requiere: Generacion Manual por Usuario " +
            Usuario.identificacion,
          escuela: curso.escuela,
          sede: curso.sede,
          operacion: "Manual"
        })
      }
    );

    const data = await response.json();

    if (data.ok) {
      Swal.fire('✅ Éxito', data.message, 'success');
      socket.emit('DiPresente', { IdCurso: idCurso });
    } else {
      Swal.fire('⚠️ Atención', data.message, 'warning');
    }
  } catch (error) {
    console.error(error);
    Swal.fire('❌ Error', 'No se pudo registrar la asistencia', 'error');
  }
};
const generarAusencias = async () => {

  try {
    // =====================================================
    // 1. FECHA LOCAL DE HOY
    // =====================================================

    const hoy = new Date();

    const fechaHoy =
      hoy.getFullYear() +
      "-" +
      String(hoy.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(hoy.getDate()).padStart(2, "0");

    // =====================================================
    // 2. SELECCIONAR FECHA
    // =====================================================

    const respuestaFecha = await Swal.fire({
      title: "📅 Generar inasistencias",
      html: `
        <div style="text-align:left; line-height:1.6">
          <p>Seleccioná la fecha para la cual querés generar el parte.</p>

          ${
            fechaDevuelta
              ? `
                <p>
                  Fecha seleccionada actualmente:
                  <b>${fechaDevuelta}</b>
                </p>
              `
              : ""
          }
        </div>
      `,
      input: "date",
      inputValue: fechaDevuelta || fechaHoy,
      inputAttributes: {
        min: curso?.fechaInicio || undefined,
        max: fechaHoy,
      },
      showCancelButton: true,
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
      inputValidator: (value) => {
        if (!value) {
          return "Debés seleccionar una fecha";
        }

        if (value > fechaHoy) {
          return "No se pueden generar inasistencias de una fecha futura";
        }
      },
    });

    if (!respuestaFecha.isConfirmed) return;

    const fechaSeleccionada = respuestaFecha.value;

    // =====================================================
    // 3. CONSULTAR PREVISUALIZACIÓN
    // =====================================================

    Swal.fire({
      title: "Calculando inasistencias...",
      html: `
        Revisando asistencias del
        <b>${fechaSeleccionada}</b>
      `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading(),
    });

    const bodyPreview = {
      cursoId: idCurso,
      division,
      fecha: fechaSeleccionada,
      escuela: curso.escuela,
      sede: curso.sede,
      usuarioSigedi: Usuario.identificacion,
      soloPrevisualizar: true,
      esEntera: true,
    };

    const previewResponse = await fetch(
      "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/generarInasistenciasCurso",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyPreview),
      }
    );

    const preview = await previewResponse.json();

    Swal.close();

    if (!preview.ok) {
      await Swal.fire(
        "⚠️ Atención",
        preview.message ||
          "No se pudieron calcular las inasistencias",
        "warning"
      );

      return;
    }

    // =====================================================
    // 4. CANTIDADES DEVUELTAS POR BACKEND
    // =====================================================

    const cantidadAusentes =
      Number(preview.cantidadAusentes) || 0;

    const totalAlumnos =
      Number(preview.totalAlumnos) ||
      alumnos.length ||
      0;

    const cantidadPresentes =
      preview.cantidadPresentes !== undefined
        ? Number(preview.cantidadPresentes)
        : totalAlumnos - cantidadAusentes;

    // =====================================================
    // 5. NO HAY AUSENTES
    // =====================================================

    if (cantidadAusentes === 0) {
      await Swal.fire({
        title: "✅ No hay inasistencias para generar",
        html: `
          <div style="text-align:left; line-height:1.7">

            <p>
              📅 Fecha:
              <b>${fechaSeleccionada}</b>
            </p>

            <p>
              👥 Total alumnos:
              <b>${totalAlumnos}</b>
            </p>

            <p>
              ✅ Presentes:
              <b>${cantidadPresentes}</b>
            </p>

            <p>
              ❌ Ausentes:
              <b>0</b>
            </p>

            <hr>

            <p>
              No se creará ninguna inasistencia.
            </p>

          </div>
        `,
        icon: "success",
      });

      return;
    }

    // =====================================================
    // 6. PRIMERA CONFIRMACIÓN
    // =====================================================

    const confirmacion = await Swal.fire({
      title: "⚠️ Confirmar generación",

      html: `
        <div style="text-align:left; line-height:1.7">

          <p>
            📅 Fecha:
            <b>${fechaSeleccionada}</b>
          </p>

          <hr>

          <p>
            👥 Total alumnos:
            <b>${totalAlumnos}</b>
          </p>

          <p>
            ✅ Presentes:
            <b>${cantidadPresentes}</b>
          </p>

          <p>
            ❌ Ausentes:
            <b>${cantidadAusentes}</b>
          </p>

          <hr>

          <div style="
            background:#fff3cd;
            border:1px solid #ffe69c;
            padding:15px;
            border-radius:8px;
            text-align:center;
          ">

            <div style="font-size:16px;">
              Se van a crear
            </div>

            <div style="
              font-size:30px;
              font-weight:bold;
              margin-top:5px;
            ">
              ${cantidadAusentes} inasistencias
            </div>

          </div>

          <br>

          <p>
            Una vez generado el parte,
            <b>no se puede deshacer automáticamente.</b>
          </p>

        </div>
      `,

      icon: "warning",

      showCancelButton: true,

      confirmButtonText:
        `Sí, crear ${cantidadAusentes} inasistencias`,

      cancelButtonText: "Cancelar",

      confirmButtonColor: "#d33",
    });

    if (!confirmacion.isConfirmed) return;

    // =====================================================
    // 7. ALERTA ESPECIAL SI TODOS ESTÁN AUSENTES
    // =====================================================

    if (
      totalAlumnos > 0 &&
      cantidadAusentes === totalAlumnos
    ) {
      const segundaConfirmacion = await Swal.fire({
        title: "🚨 TODOS FIGURAN AUSENTES",

        html: `
          <div style="text-align:left; line-height:1.7">

            <div style="
              background:#fee2e2;
              border:2px solid #dc2626;
              padding:15px;
              border-radius:8px;
              text-align:center;
            ">

              <div style="
                font-size:28px;
                font-weight:bold;
                color:#991b1b;
              ">
                ${cantidadAusentes} inasistencias
              </div>

              <div style="margin-top:8px;">
                Se generarán inasistencias para
                <b>todos los alumnos del curso</b>.
              </div>

            </div>

            <br>

            <p>
              Total alumnos:
              <b>${totalAlumnos}</b>
            </p>

            <p>
              Presentes:
              <b>${cantidadPresentes}</b>
            </p>

            <p>
              Ausentes:
              <b>${cantidadAusentes}</b>
            </p>

            <p>
              Fecha:
              <b>${fechaSeleccionada}</b>
            </p>

            <hr>

            <p>
              <b>Esta situación es poco habitual.</b>
            </p>

            <p>
              Puede significar que todavía no se registraron
              las asistencias y, por error, se está intentando
              generar el parte.
            </p>

            <p>
              Verificá los presentes antes de continuar.
            </p>

          </div>
        `,

        icon: "error",

        showCancelButton: true,

        confirmButtonText:
          `Sí, crear las ${cantidadAusentes} inasistencias`,

        cancelButtonText:
          "Cancelar y revisar asistencias",

        confirmButtonColor: "#b91c1c",

        cancelButtonColor: "#3085d6",

        reverseButtons: true,
      });

      if (!segundaConfirmacion.isConfirmed) {
        return;
      }
    }

    // =====================================================
    // 8. GENERACIÓN REAL
    // =====================================================

    Swal.fire({
      title: "Generando inasistencias...",

      html: `
        <div style="line-height:1.7">

          <p>
            Se están creando
            <b>${cantidadAusentes} inasistencias</b>.
          </p>

          <p>
            Fecha:
            <b>${fechaSeleccionada}</b>
          </p>

        </div>
      `,

      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,

      didOpen: () => Swal.showLoading(),
    });

    const body = {
      cursoId: idCurso,
      division,
      fecha: fechaSeleccionada,
      escuela: curso.escuela,
      sede: curso.sede,
      usuarioSigedi: Usuario.identificacion,
      soloPrevisualizar: false,
      esEntera: true,
    };

    const response = await fetch(
      "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/generarInasistenciasCurso",
      {
        method: "POST",
        credentials: "include",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(body),
      }
    );

    const data = await response.json();

    Swal.close();

    // =====================================================
    // 9. RESULTADO
    // =====================================================

    if (data.ok) {
      const cantidadGenerada =
        data.cantidadGenerada !== undefined
          ? Number(data.cantidadGenerada)
          : cantidadAusentes;

      await Swal.fire({
        title: "✅ Parte generado",

        html: `
          <div style="text-align:left; line-height:1.7">

            <p>
              📅 Fecha:
              <b>${fechaSeleccionada}</b>
            </p>

            <div style="
              background:#dcfce7;
              border:1px solid #86efac;
              padding:15px;
              border-radius:8px;
              text-align:center;
            ">

              <div>
                Se crearon correctamente
              </div>

              <div style="
                font-size:30px;
                font-weight:bold;
                margin-top:5px;
              ">
                ${cantidadGenerada} inasistencias
              </div>

            </div>

            ${
              data.message
                ? `
                  <br>
                  <p>${data.message}</p>
                `
                : ""
            }

          </div>
        `,

        icon: "success",
      });

      // Actualizamos la fecha seleccionada
      setFechaDevuelta(fechaSeleccionada);

      socket.emit("DiPresente", {
        IdCurso: idCurso,
        fecha: fechaSeleccionada,
      });

      return;
    }

    // =====================================================
    // ERROR DEVUELTO POR BACKEND
    // =====================================================

    Swal.fire(
      "⚠️ Atención",
      data.message ||
        "No se pudo generar el parte de inasistencias",
      "warning"
    );

  } catch (error) {
    Swal.close();

    console.error(
      "Error generando inasistencias:",
      error
    );

    Swal.fire(
      "❌ Error",
      "No se pudo generar el parte de inasistencias",
      "error"
    );
  }
};
const descargarHistoricoAusentesExcel = async (cursoId, nombreCurso) => {
  try {
    const response = await fetch(
      'https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/getAusentesCursoHistorico',
      {
        method: 'POST',
        credentials: "include",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ cursoId }),
      }
    );

    const data = await response.json();

    if (!data.ok) {
      return Swal.fire(
        '⚠️ Atención',
        data.message || 'Error al obtener histórico de ausentes',
        'warning'
      );
    }

    const fechas = data.fechas || {};

    if (!Object.keys(fechas).length) {
      return Swal.fire(
        'ℹ️ Información',
        'El curso no tiene ausencias registradas',
        'info'
      );
    }

    const workbook = XLSX.utils.book_new();

    // =====================================================
    // 📄 HOJAS POR FECHA
    // =====================================================
    Object.entries(fechas).forEach(([fecha, ausentes]) => {
      const sheetData = ausentes.map((a, index) => ({
        
        '#': index + 1,
        DNI: a.dni,
        Apellido: a.apellido,
        Nombre: a.nombres,
        División: a.division || '-',
        Observación: a.observacion || '-',
        'Fecha y hora del parte': a.fechaHoraParte,
        'Usuario SIGEDI': a.usuarioSigedi,
        Sede: a.sede,
        Escuela: a.escuela,
        Tipo: a.esEntera ? 'Falta completa' : 'Media falta',
        Valor: a.esEntera ? 1 : 0.5,
      }));
// console.log(ausentes)
      const worksheet = XLSX.utils.json_to_sheet(sheetData);
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        fecha.substring(0, 31)
      );
    });

    // =====================================================
    // 📊 HOJA RESUMEN (CON PESO REAL)
    // =====================================================
    const resumenMap = {};

    Object.entries(fechas).forEach(([fecha, ausentes]) => {
      ausentes.forEach(a => {
        const dni = String(a.dni);
        const valor = a.esEntera ? 1 : 0.5;

        if (!resumenMap[dni]) {
          resumenMap[dni] = {
            dni,
            apellido: a.apellido,
            nombres: a.nombres,
            division: a.division || '-',
            total: 0,
            fechas: [],
          };
        }

        resumenMap[dni].total += valor;
        resumenMap[dni].fechas.push(`${fecha} (${valor})`);
      });
    });

    const resumenArray = Object.values(resumenMap)
      .sort((a, b) => b.total - a.total)
      .map((r, index) => ({
        '#': index + 1,
        DNI: r.dni,
        Apellido: r.apellido,
        Nombre: r.nombres,
        División: r.division,
        'Total inasistencias (ponderado)': r.total,
        Fechas: r.fechas.join(', '),
      }));

    const resumenSheet = XLSX.utils.json_to_sheet(resumenArray);

    XLSX.utils.book_append_sheet(
      workbook,
      resumenSheet,
      'Resumen'
    );

    // =====================================================
    // 💾 DESCARGA
    // =====================================================
    const nombreArchivo = `Libro_Inasistencias_${nombreCurso || 'Curso_' + cursoId}.xlsx`;

    XLSX.writeFile(workbook, nombreArchivo);

    Swal.fire(
      '📘 Libro generado',
      'El libro de inasistencias con ponderación fue descargado correctamente',
      'success'
    );

  } catch (error) {
    console.error(error);
    Swal.fire(
      '❌ Error',
      'No se pudo generar el libro de inasistencias',
      'error'
    );
  }
};

  const [ordenCampo, setOrdenCampo] = useState(null);
  const [ordenDireccion, setOrdenDireccion] = useState("asc");
  const ordenarPor = (campo) => {
    if (ordenCampo === campo) {
      setOrdenDireccion(ordenDireccion === "asc" ? "desc" : "asc");
    } else {
      setOrdenCampo(campo);
      setOrdenDireccion("asc");
    }
  };
  const alumnosOrdenados = useMemo(() => {
    const texto = filtroAlumno.trim().toLowerCase();

    const filtrados = texto
      ? alumnos.filter(({ alumno, ni, escalafon, sub_escalafon }) =>
          [
            alumno?.alumnoDni,
            alumno?.apellido,
            alumno?.nombres,
            alumno?.emailAlumno,
            ni,
            escalafon,
            sub_escalafon,
          ].some((valor) => String(valor || '').toLowerCase().includes(texto))
        )
      : [...alumnos];

    return filtrados.sort((a, b) => {
      if (!ordenCampo) return 0;

      let valorA = a.alumno?.[ordenCampo] || '';
      let valorB = b.alumno?.[ordenCampo] || '';

      if (typeof valorA === 'string') {
        valorA = valorA.toLowerCase();
        valorB = String(valorB).toLowerCase();
      }

      if (valorA < valorB) return ordenDireccion === 'asc' ? -1 : 1;
      if (valorA > valorB) return ordenDireccion === 'asc' ? 1 : -1;
      return 0;
    });
  }, [alumnos, filtroAlumno, ordenCampo, ordenDireccion]);
  const nadie = false
  const crearInasistenciaAlumno = async (alumno, aca) => {

    try {

      // Fecha de hoy formateada
      const hoy = new Date();
      const fechaHoy = hoy.getFullYear() + "-" +
        String(hoy.getMonth() + 1).padStart(2, "0") + "-" +
        String(hoy.getDate()).padStart(2, "0");

      // 🔹 Preguntar si es hoy
      const respuesta = await Swal.fire({
        title: "📅 Registrar inasistencia",
        text: "¿La inasistencia corresponde al día de hoy?",
        icon: "question",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Sí, hoy",
        denyButtonText: "Otra fecha",
        cancelButtonText: "Cancelar"
      });

      if (respuesta.isDismissed) return;

      let fechaSeleccionada;

      // 👉 Si eligió HOY
      if (respuesta.isConfirmed) {
        fechaSeleccionada = fechaHoy;
      }

      // 👉 Si eligió OTRA FECHA
      if (respuesta.isDenied) {
        const seleccion = await Swal.fire({
          title: "Seleccionar fecha",
          input: "date",
          inputLabel: "Elegí la fecha de la inasistencia",
          inputAttributes: {
            min: curso.fechaInicio,
            max: curso.fechaFinalizacion
          },
          showCancelButton: true,
          confirmButtonText: "Registrar",
          cancelButtonText: "Cancelar",
          inputValidator: (value) => {
            if (!value) return "Debes seleccionar una fecha";
          }
        });

        if (!seleccion.isConfirmed) return;

        fechaSeleccionada = seleccion.value;
      }

      if (!fechaSeleccionada) return;

      // 🔴 Confirmación final
      const confirmar = await Swal.fire({
        title: "⚠️ Confirmar",
        html: `
        Se registrará inasistencia para:<br><br>
        <b>${fechaSeleccionada}</b>
      `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, registrar",
        confirmButtonColor: "#d33"
      });

      if (!confirmar.isConfirmed) return;

      // 🔹 Loading
      Swal.fire({
        title: "Registrando inasistencia...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading()
      });

      const res = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/crearInasistencia",
        {
          alumnoDni: alumno.alumnoDni,
          cursoId: idCurso,
          division:aca,
          fecha: fechaSeleccionada,
          escuela: curso.escuela,
          sede: curso.sede,
          usuarioSigedi: Usuario.identificacion,
          esEntera:true
        }
      );

      Swal.close();

      if (res.data.yaExistia) {
        Swal.fire("Atención", "La observacion ya estaba registrada", "info");
      } else {
        Swal.fire("Correcto", "Inasistencia creada correctamente", "success");
      }

      obtenerAlumnos();

    } catch (error) {
//       console.log(error)
      Swal.close();
      Swal.fire("Error", "No se pudo registrar la inasistencia", "error");
    }
  };

    const crearTardanzaAlumno = async (alumno, aca) => {

    try {

      // Fecha de hoy formateada
      const hoy = new Date();
      const fechaHoy = hoy.getFullYear() + "-" +
        String(hoy.getMonth() + 1).padStart(2, "0") + "-" +
        String(hoy.getDate()).padStart(2, "0");

      // 🔹 Preguntar si es hoy
      const respuesta = await Swal.fire({
        title: "📅 Registrar tardanza",
        text: "¿La tardanza corresponde al día de hoy?",
        icon: "question",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Sí, hoy",
        denyButtonText: "Otra fecha",
        cancelButtonText: "Cancelar"
      });

      if (respuesta.isDismissed) return;

      let fechaSeleccionada;

      // 👉 Si eligió HOY
      if (respuesta.isConfirmed) {
        fechaSeleccionada = fechaHoy;
      }

      // 👉 Si eligió OTRA FECHA
      if (respuesta.isDenied) {
        const seleccion = await Swal.fire({
          title: "Seleccionar fecha",
          input: "date",
          inputLabel: "Elegí la fecha de la tardanza",
          inputAttributes: {
            min: curso.fechaInicio,
            max: curso.fechaFinalizacion
          },
          showCancelButton: true,
          confirmButtonText: "Registrar",
          cancelButtonText: "Cancelar",
          inputValidator: (value) => {
            if (!value) return "Debes seleccionar una fecha";
          }
        });

        if (!seleccion.isConfirmed) return;

        fechaSeleccionada = seleccion.value;
      }

      if (!fechaSeleccionada) return;

      // 🔴 Confirmación final
      const confirmar = await Swal.fire({
        title: "⚠️ Confirmar",
        html: `
        Se registrará tardanza para:<br><br>
        <b>${fechaSeleccionada}</b>
      `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, registrar",
        confirmButtonColor: "#d33"
      });

      if (!confirmar.isConfirmed) return;

      // 🔹 Loading
      Swal.fire({
        title: "Registrando tardanza...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading()
      });

      const res = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/crearInasistencia",
        {
          alumnoDni: alumno.alumnoDni,
          cursoId: idCurso,
          division:aca,
          fecha: fechaSeleccionada,
          escuela: curso.escuela,
          sede: curso.sede,
          usuarioSigedi: Usuario.identificacion,
          esEntera:false
        }
      );

      Swal.close();

      if (res.data.yaExistia) {
        Swal.fire("Atención", "La observacion ya estaba registrada", "info");
      } else {
        Swal.fire("Correcto", "tardanza creada correctamente", "success");
      }

      obtenerAlumnos();

    } catch (error) {
//       console.log(error)
      Swal.close();
      Swal.fire("Error", "No se pudo registrar la tardanza", "error");
    }
  };

const quitarTodosLosAlumnos = async () => {

  if (!alumnosOrdenados?.length) {
    Swal.fire("Atención", "No hay alumnos para quitar", "info");
    return;
  }

  const { isConfirmed } = await Swal.fire({
    title: "⚠️ Quitar todos los alumnos",
    html: `
      Se quitarán <b>${alumnosOrdenados.length}</b> alumnos.<br><br>
      Esta acción no se puede deshacer.
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sí, quitar todos",
    cancelButtonText: "Cancelar"
  });

  if (!isConfirmed) return;

  try {

    Swal.fire({
      title: "Procesando...",
      html: `
        <b>0</b> de <b>${alumnosOrdenados.length}</b> alumnos quitados
      `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });

    const token = btoa(
      `${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`
    );

    const tamañoLote = 10;
    const total = alumnosOrdenados.length;
    let contador = 0;
    let eliminadosDni = [];

    for (let i = 0; i < total; i += tamañoLote) {

      const lote = alumnosOrdenados.slice(i, i + tamañoLote);

      for (const { alumno } of lote) {

        try {

          const response = await axios.post(
            `https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/quitaAlumno`,
            {
              alumnoDni: alumno.alumnoDni,
              idCurso,
              divisionMoodle,
              platformUrl: curso.tienePlataforma,
          usuarioSigedi: Usuario.identificacion
            },
            { headers: { Authorization: `Basic ${token}` } }
          );

          if (response.data.success) {
            contador++;
            eliminadosDni.push(String(alumno.alumnoDni));
          }

        } catch (err) {
          console.error("Error con alumno:", alumno.alumnoDni);
        }

        Swal.update({
          html: `
            <b>${contador}</b> de <b>${total}</b> alumnos quitados
          `
        });
      }
    }

    Swal.close();

    if (eliminadosDni.length > 0) {
      socket.emit('novedades matriculacion', eliminadosDni);
    }

    await obtenerAlumnos();

    Swal.fire(
      "Finalizado",
      `${contador} alumnos quitados correctamente`,
      "success"
    );

  } catch (error) {

    Swal.close();

    Swal.fire(
      "Error",
      "Ocurrió un error al quitar alumnos",
      "error"
    );
  }
};

const matricularAlumnosFaltantes = async () => {
  if (!alumnosOrdenados?.length) {
    Swal.fire("Información", "No hay alumnos para procesar", "info");
    return;
  }

  const alumnosNoMatriculados = alumnosOrdenados
    .filter(({ alumno }) => !alumno.matriculado)
    .map(({ alumno }) => ({
      alumnoDni: alumno.alumnoDni,
      apellido: alumno.apellido,
      nombres: alumno.nombres,
      emailAlumno: alumno.emailAlumno || null,
    }));

  if (!alumnosNoMatriculados.length) {
    Swal.fire(
      "Todo actualizado",
      "Todos los alumnos ya están matriculados.",
      "success"
    );
    return;
  }

  const confirmacion = await Swal.fire({
    title: "Rematricular alumnos faltantes",
    html: `
      <div style="text-align:left;line-height:1.6">
        <p>Se procesarán <b>${alumnosNoMatriculados.length}</b> alumnos.</p>
        <p>Se actualizará la matrícula interna y Moodle.</p>
      </div>
    `,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sí, procesar",
    cancelButtonText: "Cancelar",
  });

  if (!confirmacion.isConfirmed) return;

  try {
    Swal.fire({
      title: "Procesando matrículas...",
      html: `
        <b>0</b> de
        <b>${alumnosNoMatriculados.length}</b>
        alumnos procesados
      `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading(),
    });

    const resultados = [];
    const exitosos = [];
    const errores = [];

    let cantidadProcesada = 0;

    for (const alumnoActual of alumnosNoMatriculados) {
      try {
        const response = await axios.post(
          "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/matriculaDesdeLista",
          {
            alumnos: [alumnoActual],
            idCurso,
            division,
            divisionMoodle,
            platformUrl: curso?.tienePlataforma || null,
            usuarioSigedi: Usuario.identificacion,
          }
        );

        const respuesta = response.data || {};
        const procesadosBackend = Array.isArray(respuesta.procesados)
          ? respuesta.procesados
          : [];

        const erroresBackend = Array.isArray(respuesta.errores)
          ? respuesta.errores
          : [];

        if (
          respuesta.success === false ||
          respuesta.ok === false ||
          erroresBackend.length > 0
        ) {
          const primerError = erroresBackend[0];

          const mensaje =
            primerError?.detalle ||
            primerError?.motivo ||
            primerError?.message ||
            respuesta.message ||
            "No se pudo matricular el alumno.";

          const resultadoError = {
            dni: alumnoActual.alumnoDni,
            ok: false,
            error: mensaje,
            respuesta,
          };

          resultados.push(resultadoError);
          errores.push(resultadoError);
        } else {
          const resultadoExitoso = {
            dni: alumnoActual.alumnoDni,
            ok: true,
            procesados: procesadosBackend,
            respuesta,
          };

          resultados.push(resultadoExitoso);
          exitosos.push(resultadoExitoso);
        }
      } catch (error) {
        const mensaje =
          error.response?.data?.detalle ||
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Error desconocido.";

        console.error(
          "❌ Error rematriculando alumno:",
          alumnoActual.alumnoDni,
          error.response?.data || error.message
        );

        const resultadoError = {
          dni: alumnoActual.alumnoDni,
          ok: false,
          error: mensaje,
        };

        resultados.push(resultadoError);
        errores.push(resultadoError);
      }

      cantidadProcesada++;

      Swal.update({
        html: `
          <b>${cantidadProcesada}</b> de
          <b>${alumnosNoMatriculados.length}</b>
          alumnos procesados
        `,
      });
    }

    Swal.close();

//     console.log("✅ Resultados completos:", resultados);

    if (exitosos.length > 0) {
      socket.emit(
        "novedades matriculacion",
        exitosos.map((resultado) => String(resultado.dni))
      );
    }

    await obtenerAlumnos();

    const detalleErrores = errores
      .slice(0, 12)
      .map(
        ({ dni, error }) => `
          <div style="
            margin:7px 0;
            padding:8px 10px;
            text-align:left;
            background:#fff7ed;
            border:1px solid #fed7aa;
            border-radius:8px;
          ">
            <b>DNI ${dni}</b><br>
            <span>${error}</span>
          </div>
        `
      )
      .join("");

    await Swal.fire({
      title:
        errores.length > 0
          ? "Proceso finalizado con observaciones"
          : "Rematriculación finalizada",
      html: `
        <div style="line-height:1.6">
          <p>✅ Correctos: <b>${exitosos.length}</b></p>
          <p>⚠️ Con errores: <b>${errores.length}</b></p>

          ${
            errores.length > 0
              ? `
                <hr>
                ${detalleErrores}
                ${
                  errores.length > 12
                    ? `<p><b>Y ${errores.length - 12} errores más.</b></p>`
                    : ""
                }
              `
              : ""
          }
        </div>
      `,
      icon: errores.length > 0 ? "warning" : "success",
    });
  } catch (error) {
    Swal.close();

    console.error(
      "❌ Error general procesando matrículas:",
      error.response?.data || error.message
    );

    Swal.fire(
      "Error",
      error.response?.data?.message ||
        error.response?.data?.detalle ||
        "Ocurrió un error procesando las matrículas.",
      "error"
    );
  }
};
  const indicadorOrden = (campo) => {
    if (ordenCampo !== campo) return '↕';
    return ordenDireccion === 'asc' ? '↑' : '↓';
  };

  return (
    <div className="tac-shell">
      <header className="tac-header">
        <div className="tac-header-main">
          <div className="tac-header-icon">🎓</div>
          <div>
            <p className="tac-eyebrow">Gestión del curso</p>
            <h2>{nombreCurso || curso?.nombreCurso || 'Alumnos del curso'}</h2>
            <div className="tac-meta">
              <span>División {division}</span>
              <span>{alumnos.length} alumnos</span>
              {loadingDivision && <span>Sincronizando Moodle…</span>}
            </div>
          </div>
        </div>

        <nav className="tac-tabs" aria-label="Módulos del curso">
          {[
            { key: 'matriculaciones', label: 'Matrículas', icon: '👥' },
            !nadie && {
              key: 'asistencias',
              label: 'Asistencias',
              icon: '✓',
              ocultar: escuelaDePolicia,
            },
          ]
            .filter(Boolean)
            .filter((tab) => !tab.ocultar)
            .map((tab) => (
              <button
                type="button"
                key={tab.key}
                className={`tac-tab ${moduloActivo === tab.key ? 'is-active' : ''}`}
                onClick={() => setModuloActivo(tab.key)}
              >
                <span>{tab.icon}</span>
                {tab.label}
              </button>
            ))}
        </nav>
      </header>

      {moduloActivo === 'matriculaciones' && (
        <section className="tac-panel">
          <div className="tac-toolbar">
            <div className="tac-search-wrap">
              <span>⌕</span>
              <input
                type="search"
                value={filtroAlumno}
                onChange={(e) => setFiltroAlumno(e.target.value)}
                placeholder="Buscar por DNI, apellido, nombre, email, NI…"
                aria-label="Buscar alumno"
              />
              {filtroAlumno && (
                <button type="button" onClick={() => setFiltroAlumno('')} title="Limpiar búsqueda">
                  ×
                </button>
              )}
            </div>

            <div className="tac-toolbar-actions">
              <button
                type="button"
                className="tac-btn tac-btn-success"
                onClick={descargarExcelAlumnos}
                disabled={!alumnosOrdenados.length}
              >
                ↓ Excel
              </button>
              <button type="button" className="tac-btn tac-btn-light" onClick={descargarEjemploExcel}>
                Archivo ejemplo
              </button>
            </div>
          </div>

          <div className="tac-admin-grid">
            <div className="tac-upload-card">
              <div>
                <strong>Importar alumnos</strong>
                <small>Cargá el archivo Excel o CSV con las matrículas.</small>
              </div>
              <FileUpload datos={handleCsvUpload} />
            </div>

            <div className="tac-bulk-actions">
              {comprueboPermisos(Usuario.funcion, 'Rematriculo Alumnos del Listado') && (
                <button type="button" className="tac-btn tac-btn-primary" onClick={matricularAlumnosFaltantes}>
                  ↻ Rematricular faltantes
                </button>
              )}

              {Usuario.destino == 7 && alumnos.length > 0 && (
                <>
                  <button type="button" className="tac-btn tac-btn-warning" onClick={suspenderTodosLosAlumnos}>
                    Suspender todos
                  </button>
                  <button type="button" className="tac-btn tac-btn-danger" onClick={quitarTodosLosAlumnos}>
                    Quitar todos
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="tac-table-card">
<div className="tac-table-title">
  <div>
    <h3>Alumnos matriculados</h3>

    <p>
      Mostrando <strong>{alumnosOrdenados.length}</strong> de{" "}
      <strong>{alumnos.length}</strong>
    </p>
  </div>

  {divisionMoodle && (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: "10px",
        flexWrap: "wrap",
      }}
    >
      <span className="tac-badge">
        Moodle:{" "}
        {divisionMoodle.division ||
          divisionMoodle.nombreCurso ||
          `ID ${divisionMoodle.id}`}
      </span>

      <button
        type="button"
        className="tac-btn tac-btn-primary"
        onClick={abrirAulaDivision}
        disabled={loadingDivision || ingresandoAula}
        title="Verificar matrícula e ingresar al aula Moodle de esta división"
      >
        {loadingDivision
          ? "Buscando aula..."
          : ingresandoAula
          ? "Preparando acceso..."
          : "🎓 Ir al aula Moodle"}
      </button>
    </div>
  )}
</div>

            <div className="tac-table-scroll">
              <table className="tac-table">
                <thead>
                  <tr>
                    <th className="tac-col-number">#</th>
                    {[
                      ['alumnoDni', 'DNI'],
                      ['apellido', 'Apellido'],
                      ['nombres', 'Nombres'],
                      ['emailAlumno', 'Email'],
                    ].map(([campo, titulo]) => (
                      <th key={campo}>
                        <button type="button" className="tac-sort" onClick={() => ordenarPor(campo)}>
                          {titulo} <span>{indicadorOrden(campo)}</span>
                        </button>
                      </th>
                    ))}
                    <th>NI</th>
                    <th>Escalafón</th>
                    <th>Subescalafón</th>
                    <th className="tac-actions-head">Acciones</th>
                  </tr>
                </thead>

                <tbody>
                  {alumnosOrdenados.map(({ alumno, ni, escalafon, sub_escalafon }, index) => (
                    <tr key={alumno.alumnoDni}>
                      <td data-label="#" className="tac-index">{index + 1}</td>
                      <td data-label="DNI"><strong>{alumno.alumnoDni}</strong></td>
                      <td data-label="Apellido">{alumno.apellido || '—'}</td>
                      <td data-label="Nombres">{alumno.nombres || '—'}</td>
                      <td data-label="Email" className="tac-email">{alumno.emailAlumno || '—'}</td>
                      <td data-label="NI"><span className="tac-chip">{ni || 'Sin datos'}</span></td>
                      <td data-label="Escalafón">{escalafon || '—'}</td>
                      <td data-label="Subescalafón">{sub_escalafon || '—'}</td>
                      <td data-label="Acciones">
                        <div className="tac-row-actions">
                          {!escuelaDePolicia && (
                            <>
                              <button
                                type="button"
                                className="tac-icon-btn tac-icon-neutral"
                                onClick={() => crearTardanzaAlumno(alumno, division)}
                                title="Marcar tardanza"
                              >
                                ⏱
                              </button>
                              <button
                                type="button"
                                className="tac-icon-btn tac-icon-warning"
                                onClick={() => crearInasistenciaAlumno(alumno, division)}
                                title="Marcar ausente"
                              >
                                A
                              </button>
                            </>
                          )}

                          {comprueboPermisos(Usuario.funcion, 'suspendo alumno') && (
                            <button
                              type="button"
                              className="tac-icon-btn tac-icon-danger-soft"
                              onClick={() => desmatricular(alumno)}
                              title="Suspender alumno"
                            >
                              ⏸
                            </button>
                          )}

                          {(Usuario.destino == 7 || comprueboPermisos(Usuario.funcion, 'Borro Alumno')) && (
                            <button
                              type="button"
                              className="tac-icon-btn tac-icon-danger"
                              onClick={() => quitaAlumno(alumno)}
                              title="Quitar alumno"
                            >
                              ×
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}

                  {!alumnosOrdenados.length && (
                    <tr>
                      <td colSpan="9" className="tac-empty">
                        <span>👤</span>
                        <strong>{filtroAlumno ? 'No encontramos coincidencias' : 'No hay alumnos en esta división'}</strong>
                        <small>{filtroAlumno ? 'Probá con otro DNI, apellido o nombre.' : 'Podés importar alumnos desde el panel superior.'}</small>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      )}

      {moduloActivo === 'asistencias' && (
        <section className="tac-panel">
          <div className="tac-attendance-actions">
            <button type="button" className="tac-btn tac-btn-success" onClick={doyPresente}>
              + Registrar presente
            </button>
            <button type="button" className="tac-btn tac-btn-danger" onClick={generarAusencias}>
              Generar ausencia automaticamente
            </button>
            <button
              type="button"
              className="tac-btn tac-btn-warning"
              onClick={() => descargarHistoricoAusentesExcel(idCurso, curso.nombreCurso)}
            >
              ↓ Libro de inasistencias
            </button>
          </div>

          <div className="tac-content-card">
            <AsistenciasCurso
              idCurso={idCurso}
              division={division}
              curso={curso}
              devuelvoFecha={(x) => setFechaDevuelta(x)}
            />
          </div>

          <div className="tac-content-card tac-orphans">
            <DetectarHuerfanos plataformaUrl="https://cursos.isepsantafe.net.ar/" />
          </div>
        </section>
      )}


      {mostrarRevisionMatricula && analisisMatricula && (
        <div className="tac-matricula-modal-backdrop">
          <div className="tac-matricula-modal">
            <div className="tac-matricula-modal-header">
              <div>
                <p className="tac-eyebrow">Paso 1 completado</p>
                <h3>Revisión de matrícula</h3>
                <p>
                  Revisá quién será matriculado y en qué materias antes de ejecutar.
                </p>
              </div>

              <button
                type="button"
                className="tac-matricula-close"
                onClick={cerrarRevisionMatricula}
                disabled={ejecutandoMatricula}
                aria-label="Cerrar revisión"
              >
                ×
              </button>
            </div>

            <div className="tac-matricula-summary">
              <div>
                <span>Recibidos</span>
                <strong>{analisisMatricula.resumen?.totalRecibidos || 0}</strong>
              </div>
              <div>
                <span>Válidos</span>
                <strong>{analisisMatricula.resumen?.validos || 0}</strong>
              </div>
              <div>
                <span>Con todas</span>
                <strong>{analisisMatricula.resumen?.todasLasMaterias || 0}</strong>
              </div>
              <div>
                <span>Solo académicas</span>
                <strong>{analisisMatricula.resumen?.soloAcademicas || 0}</strong>
              </div>
              <div>
                <span>Revisión</span>
                <strong>{analisisMatricula.resumen?.requierenRevision || 0}</strong>
              </div>
              <div>
                <span>Errores</span>
                <strong>{analisisMatricula.resumen?.invalidos || 0}</strong>
              </div>
            </div>

            {(analisisMatricula.materias?.todas || []).length === 0 ? (
              <div className="tac-matricula-info">
                <strong>Curso sin materias Moodle</strong>
                <span>
                  Se realizará únicamente la matrícula interna de los alumnos seleccionados.
                </span>
              </div>
            ) : (
              <div className="tac-matricula-toolbar">
                <div>
                  <strong>Selección rápida</strong>
                  <small>
                    Las operacionales masivas solo se aplican a quienes están habilitados por escalafón.
                  </small>
                </div>

                <div>
                  <button
                    type="button"
                    className="tac-btn tac-btn-light"
                    onClick={() => seleccionarMateriasGrupo("academica", true)}
                  >
                    Todas las académicas
                  </button>
                  <button
                    type="button"
                    className="tac-btn tac-btn-light"
                    onClick={() => seleccionarMateriasGrupo("operacional", true)}
                  >
                    Operacionales habilitados
                  </button>
                  <button
                    type="button"
                    className="tac-btn tac-btn-light"
                    onClick={() => {
                      seleccionarMateriasGrupo("academica", false);
                      seleccionarMateriasGrupo("operacional", false);
                    }}
                  >
                    Limpiar materias
                  </button>
                </div>
              </div>
            )}

            <div className="tac-matricula-list">
              {analisisMatricula.alumnos.map((registro) => {
                const materiasSeleccionadas = Array.isArray(
                  registro.materiasSeleccionadas
                )
                  ? registro.materiasSeleccionadas.map(Number)
                  : [];

                return (
                  <article
                    key={`${registro.fila}-${registro.alumnoDni || "sin-dni"}`}
                    className={`tac-matricula-alumno ${
                      !registro.valido
                        ? "is-error"
                        : registro.clasificacion === "sin_escalafon_revision"
                          ? "is-review"
                          : ""
                    }`}
                  >
                    <div className="tac-matricula-alumno-head">
                      <label className="tac-matricula-check-main">
                        <input
                          type="checkbox"
                          checked={Boolean(registro.matricular)}
                          disabled={!registro.valido || ejecutandoMatricula}
                          onChange={() => cambiarMatriculaAlumno(registro)}
                        />
                        <span>
                          <strong>
                            {registro.apellido || "Sin apellido"},{" "}
                            {registro.nombres || "Sin nombres"}
                          </strong>
                          <small>
                            DNI {registro.alumnoDni || "sin DNI"} · Fila {registro.fila}
                          </small>
                        </span>
                      </label>

                      <div className="tac-matricula-tags">
                        {registro.puedeCursarOperacionales ? (
                          <span className="is-success">General: todas</span>
                        ) : registro.escalafonPolicia?.existe ? (
                          <span className="is-info">Solo académicas</span>
                        ) : (
                          <span className="is-warning">Sin escalafón</span>
                        )}

                        {registro.autorizaOperacionales && (
                          <span className="is-manual">Autorización manual</span>
                        )}

                        {!registro.valido && (
                          <span className="is-danger">No procesable</span>
                        )}
                      </div>
                    </div>

                    <div className="tac-matricula-datos">
                      <span>
                        <b>NI:</b> {registro.escalafonPolicia?.ni || "Sin datos"}
                      </span>
                      <span>
                        <b>Escalafón:</b>{" "}
                        {registro.escalafonPolicia?.escalafon || "Sin datos"}
                      </span>
                      <span>
                        <b>Subescalafón:</b>{" "}
                        {registro.escalafonPolicia?.sub_escalafon || "Sin datos"}
                      </span>
                    </div>

                    {registro.errores?.length > 0 && (
                      <div className="tac-matricula-messages is-error-message">
                        {registro.errores.map((mensaje, index) => (
                          <span key={index}>• {mensaje}</span>
                        ))}
                      </div>
                    )}

                    {registro.advertencias?.length > 0 && (
                      <details className="tac-matricula-warnings">
                        <summary>
                          Ver {registro.advertencias.length} advertencia(s)
                        </summary>
                        {registro.advertencias.map((mensaje, index) => (
                          <span key={index}>• {mensaje}</span>
                        ))}
                      </details>
                    )}

                    {registro.valido &&
                      registro.matricular &&
                      (analisisMatricula.materias?.todas || []).length > 0 && (
                        <div className="tac-matricula-materias">
                          {(analisisMatricula.materias?.todas || []).map(
                            (materia) => {
                              const seleccionada = materiasSeleccionadas.includes(
                                Number(materia.courseid)
                              );
                              const sinClasificar =
                                materia.tipo === "sin_clasificar";
                              const requiereAutorizacion =
                                materia.tipo === "operacional" &&
                                !registro.puedeCursarOperacionales;

                              return (
                                <label
                                  key={materia.courseid}
                                  className={`tac-materia-option ${
                                    seleccionada ? "is-selected" : ""
                                  } ${sinClasificar ? "is-disabled" : ""}`}
                                  title={
                                    sinClasificar
                                      ? materia.motivoSinClasificar ||
                                        "Materia no clasificada"
                                      : requiereAutorizacion
                                        ? "Requiere autorización manual"
                                        : ""
                                  }
                                >
                                  <input
                                    type="checkbox"
                                    checked={seleccionada}
                                    disabled={sinClasificar || ejecutandoMatricula}
                                    onChange={() =>
                                      cambiarMateriaAlumno(registro, materia)
                                    }
                                  />

                                  <span>
                                    <strong>{materia.nombre}</strong>
                                    <small>
                                      {materia.tipo === "academica"
                                        ? "Académica"
                                        : materia.tipo === "operacional"
                                          ? requiereAutorizacion
                                            ? "Operacional · requiere autorización"
                                            : "Operacional"
                                          : "Sin clasificar"}
                                    </small>
                                  </span>
                                </label>
                              );
                            }
                          )}
                        </div>
                      )}
                  </article>
                );
              })}
            </div>

            <div className="tac-matricula-footer">
              <button
                type="button"
                className="tac-btn tac-btn-light"
                onClick={cerrarRevisionMatricula}
                disabled={ejecutandoMatricula}
              >
                Cancelar
              </button>

              <button
                type="button"
                className="tac-btn tac-btn-primary"
                onClick={ejecutarMatriculaAnalizada}
                disabled={
                  ejecutandoMatricula ||
                  !analisisMatricula.alumnos.some(
                    (registro) => registro.valido && registro.matricular
                  )
                }
              >
                {ejecutandoMatricula
                  ? "Ejecutando..."
                  : "Confirmar y matricular"}
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .tac-matricula-modal-backdrop {
          position: fixed;
          inset: 0;
          z-index: 9998;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 18px;
          background: rgba(15, 23, 42, 0.72);
          backdrop-filter: blur(4px);
        }

        .tac-matricula-modal {
          width: min(1180px, 100%);
          max-height: 94vh;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          border-radius: 18px;
          background: #f8fafc;
          box-shadow: 0 24px 80px rgba(15, 23, 42, 0.35);
        }

        .tac-matricula-modal-header,
        .tac-matricula-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          padding: 18px 22px;
          background: #ffffff;
          border-bottom: 1px solid #e2e8f0;
        }

        .tac-matricula-modal-header h3 {
          margin: 0;
          font-size: 1.35rem;
        }

        .tac-matricula-modal-header p {
          margin: 4px 0 0;
          color: #64748b;
        }

        .tac-matricula-close {
          width: 40px;
          height: 40px;
          border: 0;
          border-radius: 50%;
          font-size: 1.7rem;
          cursor: pointer;
          background: #f1f5f9;
          color: #334155;
        }

        .tac-matricula-summary {
          display: grid;
          grid-template-columns: repeat(6, minmax(100px, 1fr));
          gap: 10px;
          padding: 14px 22px;
          background: #ffffff;
          border-bottom: 1px solid #e2e8f0;
        }

        .tac-matricula-summary > div {
          padding: 10px 12px;
          border-radius: 12px;
          background: #f1f5f9;
        }

        .tac-matricula-summary span,
        .tac-matricula-summary strong {
          display: block;
        }

        .tac-matricula-summary span {
          color: #64748b;
          font-size: 0.78rem;
        }

        .tac-matricula-summary strong {
          margin-top: 2px;
          font-size: 1.25rem;
          color: #0f172a;
        }

        .tac-matricula-info,
        .tac-matricula-toolbar {
          margin: 14px 22px 0;
          padding: 12px 14px;
          border-radius: 12px;
          background: #e0f2fe;
          color: #075985;
        }

        .tac-matricula-info {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .tac-matricula-toolbar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 14px;
          background: #ffffff;
          color: #334155;
          border: 1px solid #e2e8f0;
        }

        .tac-matricula-toolbar small {
          display: block;
          margin-top: 3px;
          color: #64748b;
        }

        .tac-matricula-toolbar > div:last-child {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .tac-matricula-list {
          flex: 1;
          overflow-y: auto;
          padding: 14px 22px 22px;
        }

        .tac-matricula-alumno {
          margin-bottom: 12px;
          padding: 15px;
          border: 1px solid #dbe4ef;
          border-radius: 14px;
          background: #ffffff;
        }

        .tac-matricula-alumno.is-review {
          border-color: #f59e0b;
        }

        .tac-matricula-alumno.is-error {
          border-color: #ef4444;
          background: #fff7f7;
        }

        .tac-matricula-alumno-head {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 14px;
        }

        .tac-matricula-check-main {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          cursor: pointer;
        }

        .tac-matricula-check-main input {
          width: 18px;
          height: 18px;
          margin-top: 2px;
        }

        .tac-matricula-check-main span,
        .tac-matricula-check-main small {
          display: block;
        }

        .tac-matricula-check-main small {
          margin-top: 2px;
          color: #64748b;
        }

        .tac-matricula-tags {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-end;
          gap: 6px;
        }

        .tac-matricula-tags span {
          padding: 5px 8px;
          border-radius: 999px;
          font-size: 0.75rem;
          font-weight: 700;
        }

        .tac-matricula-tags .is-success {
          background: #dcfce7;
          color: #166534;
        }

        .tac-matricula-tags .is-info {
          background: #dbeafe;
          color: #1d4ed8;
        }

        .tac-matricula-tags .is-warning {
          background: #fef3c7;
          color: #92400e;
        }

        .tac-matricula-tags .is-manual {
          background: #ffedd5;
          color: #9a3412;
        }

        .tac-matricula-tags .is-danger {
          background: #fee2e2;
          color: #991b1b;
        }

        .tac-matricula-datos {
          display: flex;
          flex-wrap: wrap;
          gap: 8px 18px;
          margin-top: 10px;
          color: #475569;
          font-size: 0.86rem;
        }

        .tac-matricula-messages,
        .tac-matricula-warnings {
          display: flex;
          flex-direction: column;
          gap: 3px;
          margin-top: 10px;
          font-size: 0.84rem;
        }

        .is-error-message {
          color: #b91c1c;
        }

        .tac-matricula-warnings {
          color: #92400e;
        }

        .tac-matricula-warnings summary {
          cursor: pointer;
          font-weight: 700;
        }

        .tac-matricula-materias {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
          gap: 8px;
          margin-top: 13px;
          padding-top: 13px;
          border-top: 1px solid #e2e8f0;
        }

        .tac-materia-option {
          display: flex;
          align-items: flex-start;
          gap: 9px;
          padding: 10px;
          border: 1px solid #dbe4ef;
          border-radius: 10px;
          cursor: pointer;
          background: #f8fafc;
        }

        .tac-materia-option.is-selected {
          border-color: #2563eb;
          background: #eff6ff;
        }

        .tac-materia-option.is-disabled {
          cursor: not-allowed;
          opacity: 0.58;
        }

        .tac-materia-option input {
          margin-top: 3px;
        }

        .tac-materia-option span,
        .tac-materia-option small {
          display: block;
        }

        .tac-materia-option small {
          margin-top: 3px;
          color: #64748b;
        }

        .tac-matricula-footer {
          border-top: 1px solid #e2e8f0;
          border-bottom: 0;
          justify-content: flex-end;
        }

        @media (max-width: 850px) {
          .tac-matricula-modal-backdrop {
            padding: 0;
          }

          .tac-matricula-modal {
            height: 100vh;
            max-height: 100vh;
            border-radius: 0;
          }

          .tac-matricula-summary {
            grid-template-columns: repeat(3, 1fr);
          }

          .tac-matricula-toolbar,
          .tac-matricula-alumno-head {
            align-items: stretch;
            flex-direction: column;
          }

          .tac-matricula-tags {
            justify-content: flex-start;
          }
        }

        @media (max-width: 520px) {
          .tac-matricula-summary {
            grid-template-columns: repeat(2, 1fr);
          }

          .tac-matricula-list,
          .tac-matricula-modal-header,
          .tac-matricula-footer {
            padding-left: 14px;
            padding-right: 14px;
          }
        }
      `}</style>

      {mostrarQR && (
        <ScannerAsistenciaQR
          onClose={() => setMostrarQR(false)}
          idCurso={idCurso}
          curso={curso}
          Usuario={Usuario}
          socket={socket}
        />
      )}
    </div>
  );
};

export default TablaAlumnosCurso;
